import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

import { createI18n } from 'vue-i18n'
import { FontAwesomeIcon } from '@/application/helpers/fontawesomeIcons'
import { initializeFirebase } from '@/services/firebase/firebase'
import './assets/themes/base.css'
import './assets/styles/main.css'

import 'leaflet/dist/leaflet.css'

import '@vueform/slider/themes/default.css'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'

import Appsignal from '@appsignal/javascript'
import { errorHandler } from '@appsignal/vue'

import { plugin as breadcrumbsNetworkPlugin } from '@appsignal/plugin-breadcrumbs-network'
import { plugin as pathDecoratorPlugin } from '@appsignal/plugin-path-decorator'

// The VITE_APP_REVISION will be replaced by its actual value during the Vite build process.
console.log('VITE_APPSIGNAL_KEY:', import.meta.env.VITE_APPSIGNAL_KEY)
console.log('VITE_APP_REVISION:', import.meta.env.VITE_APP_REVISION || 'default-revision')
const appsignal = new Appsignal({
  key: import.meta.env.VITE_APPSIGNAL_KEY,
  revision: import.meta.env.VITE_APP_REVISION || 'default-revision'
})
const breadcrumbsNetworkOptions = {}
appsignal.use(breadcrumbsNetworkPlugin(breadcrumbsNetworkOptions))
appsignal.use(pathDecoratorPlugin())

const i18n = createI18n({
  legacy: false, // For Vue 3
  locale: 'en',
  warnHtmlMessage: false,
  // Specify your default locale, even though it is not actively utilized, as it is a requirement for the proper functioning of the plugin.
  messages: {
    // Set the initial translations; these will be updated dynamically in the `beforeEach` guard
    en: {}
  }
})

document.addEventListener('DOMContentLoaded', async () => {
  // Initialize Firebase asynchronously before mounting the app
  initializeFirebase().then(() => {
    const app = createApp(App)
    app.component('FontAwesomeIcon', FontAwesomeIcon)
    app.component('VueDatePicker', VueDatePicker)
    app.config.globalProperties.$t = i18n.global.t
    app.config.errorHandler = errorHandler(appsignal, app)

    app.use(createPinia())
    app.use(router)
    // app.use(i18n) // This approach is not used as we export the i18n globally instead

    app.mount('#app')
  })
})
export default i18n
